
/*
 lans = {
     name: [zh-CN, zh-TW, ...en(other)]
 }

name: module+value
*/
import lanInfo from './i18nInfo.JSON'
// console.log(lanInfo)

const getLan = function(name, mode, valueInfo) {
    let type = this.bus.nowLan
    if (mode === 1) {
        return valueInfo
    }
    if (mode === 2) {
        console.log(valueInfo)
        if (!valueInfo[type]) {
            return valueInfo.en
        }
        return valueInfo[type]
    }
    
    if (!lanInfo[name]) {
        return ''
    }
    if (!lanInfo[name][type]) {
        return lanInfo[name]['en']
    }
    return lanInfo[name][type]
}

const getImg = function(nameList) {
    let type = this.bus.nowLan
    if (nameList.length === 2 && type !== 'zh-CN') {
        return nameList[nameList.length - 1]
    }
    if (type === 'zh-CN') {
        return nameList[0]
    } else if (type === 'zh-TW') {
        return nameList[1]
    } else {
        return nameList[nameList.length - 1]
    }
}
const isEn = function() {
    return this.bus.nowLan === ''
}
export {
    getLan,
    getImg,
    isEn
}


// WEBPACK FOOTER //
// ./src/i18n/i18nLan.js